// 探访问卷
import request from "./index.js";
const API = {
	crmVisitSurveyInfoURL: "/crm-service/crm/crmVisitSurvey/info",
	crmVisitSurveyAddURL: "/crm-service/crm/crmVisitSurvey/add",
	crmVisitAddURL: "/crm-service/crm/crmVisit/add",
	crmVisitGroupByAllURL: "/crm-service/crm/crmVisit/groupByAll",
}

const visitSurveyInfo = (params={}) => {
	return request.get(API.crmVisitSurveyInfoURL, { params })
}

const visitSurveyAdd = (data={}) => {
	return request.post(API.crmVisitSurveyAddURL, data)
}

const visitGroupByAll = (params={}) => {
	return request.get(API.crmVisitGroupByAllURL, { params })
}

const visitAdd = (data={}) => {
	return request.post(API.crmVisitAddURL, data)
}

export {
	visitSurveyInfo,
	visitSurveyAdd,
	visitGroupByAll,
	visitAdd
}
